import { z } from 'zod';

export const UnsubscribeQuerySchema = z.object({
  token: z.string(),
});
